<template>
  <div class="setting-header fixed-top">
    <h1 class="setting-header__heading">
      <IconButton
        variant="flat"
        icon="arrow_back_ios"
        @click="() => $router.go(-1)" />
      <slot />
    </h1>
  </div>
</template>

<script>
import IconButton from '@/components/parts/IconButton.vue'
export default {
  components: {
    IconButton
  }
}
</script>

<style lang="scss" scoped>
.setting-header {
  display: flex;
  width: 100%;
  background-color: $l-blue;
  padding: 12px;
  @media screen and (min-width:992px) {
    right: 0;
    left: 120px;
  }
  &__heading{
    display: flex;
    align-items: center;
    color: $white;
    font-size: $fs-lg;
    font-weight: bold;
  }
}
</style>